import {DeviceInfoVo} from '../../common/shared/api/nicolas/vo/DeviceInfoVo.interface';
import {DeviceInfo} from '../generated/types';
import {createDevice} from './Device';

export function createDeviceInfo({
  device_list,
  device_replaceable_count,
  device_limit_count,
}: DeviceInfoVo): DeviceInfo {
  return {
    deviceList: device_list.map(device => createDevice(device)),
    deviceReplaceableCount: device_replaceable_count,
    deviceLimitCount: device_limit_count,
  };
}
